import React from 'react';
import moment from 'moment-timezone';
import { Box, Typography, Button } from '@material-ui/core';
import { useSelector, shallowEqual } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { userInfoSelector } from 'redux/custom-selector';
import SvgFreetrialRestrictions from '../../../icons/svgFreeTrialRestrictions';
import { planTypeDisplay } from './planTypeDisplay';
import { colors } from 'constants/colors';
import { PricingPlan } from 'constants/pricingPlan';

export const PlanDetailsExpiredMenu = ({ setPlanMenuOption }) => {
  const match = useRouteMatch();
  const history = useHistory();
  const { UserInfo } = useSelector(userInfoSelector, shallowEqual);
  const planExpiryDate = new Date(Number(UserInfo.subscription_end_date_milli));
  const planExpiry = moment(planExpiryDate).format('D MMM, YYYY');

  return (
    <Box className="dropDownBody">
      <Box className="choosePlan" display="flex" alignItems="center">
        <Box width="100%">
          <Box className="currentPlan" display="flex" mb={1} p={2} alignItems="center">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%">
              <Box>
                <Typography variant="h6" component="h6">
                  {planTypeDisplay(UserInfo)}
                </Typography>
              </Box>
              <Box>
                <Button size="small" className="expired-btn" disabled>
                  {' '}
                  Expired{' '}
                </Button>
              </Box>
            </Box>
          </Box>
          <Box className="expiredPlan" mb={1}>
            <Box mb={2}>
              <Typography variant="h6" component="h6" display="block">
                {UserInfo.planName === PricingPlan.FREE
                  ? `Your ${planTypeDisplay(UserInfo)} Is Expired`
                  : `Your ${planTypeDisplay(UserInfo)} Expired on  ${planExpiry}`}
              </Typography>
            </Box>
            <Box className="expiredSVG">
              <SvgFreetrialRestrictions />
            </Box>
          </Box>
          <Box textAlign="center" className="upgradeActionPlan" mt={1}>
            <Box mb={1}>
              <Typography variant="body2" component="label" color={colors.textSecondary}>
                We hope you enjoyed your {planTypeDisplay(UserInfo)}, Please Choose your plan
                to proceed
              </Typography>
            </Box>
            {match.path !== '/plans' ? (
              <Button
                onClick={() => {
                  history.push('/plans');
                  setPlanMenuOption(false);
                }}
                className="uppercase"
                variant="contained"
                color={colors.primary}
                size="small">
                Upgrade
              </Button>
            ) : (
              false
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
